type NaverWcsCommand = () => void;

const pendingCommands: NaverWcsCommand[] = [];
let isWcsScriptLoaded = false;

/**
 * wcslog.js(afterInteractive) 로드 후 실행을 보장하는 커맨드 큐.
 * 로드 전 호출은 적재되고 onLoad flush 때 순서대로 실행된다 — gtag dataLayer와 같은 패턴.
 * 반환된 cleanup으로 미실행 커맨드를 취소할 수 있다.
 */
export const runOnNaverWcsReady = (command: NaverWcsCommand) => {
  if (isWcsScriptLoaded) {
    command();

    return () => {};
  }

  pendingCommands.push(command);

  return () => {
    const commandIndex = pendingCommands.indexOf(command);

    if (commandIndex !== -1) {
      pendingCommands.splice(commandIndex, 1);
    }
  };
};

export const flushNaverWcsCommands = () => {
  isWcsScriptLoaded = true;

  while (pendingCommands.length > 0) {
    pendingCommands.shift()?.();
  }
};
